import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { DropSwitch } from './DropToggles';
import { RestockPushPreview } from './RestockPushPreview';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Per-region Sold out + Hide from menu switches for an inventory row.
export const AvailabilityControls = ({ product, region, onChange }) => {
  const [busy, setBusy] = useState(null);
  const [restock, setRestock] = useState(null);
  if (!region || (product.regions?.length && !product.regions.includes(region))) return null;
  const soldOut = (product.sold_out_regions || []).includes(region);
  const hidden = (product.hidden_regions || []).includes(region);
  const auto = !!product.sold_out_meta?.[region]?.auto;
  const waiting = Number(product.restock_waiting?.[region] || 0);
  const flip = async (field, value) => {
    setBusy(field);
    try {
      const { data } = await axios.patch(`${API_URL}/api/products/${product.id}/availability`, { region, [field]: value }, { withCredentials: true });
      toast.success(`${product.name} · ${region.toUpperCase()}: ${field === 'hidden' ? (value ? 'hidden from menu' : 'back on menu') : (value ? 'Sold out' : 'orderable again')}`);
      if (field === 'sold_out' && !value && data.waiting > 0 && !hidden) setRestock({ productId: product.id, region });
      onChange?.();
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Could not update');
    } finally { setBusy(null); }
  };
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-2 mt-2" data-testid={`availability-${product.id}`}>
      <label className="flex items-center gap-2 font-mono text-[10px] uppercase text-[#A3C7A8]">
        <DropSwitch on={soldOut} busy={busy === 'sold_out'} onClick={() => flip('sold_out', !soldOut)} testId={`sold-out-toggle-${product.id}`} />
        Sold out
      </label>
      <label className="flex items-center gap-2 font-mono text-[10px] uppercase text-[#A3C7A8]">
        <DropSwitch on={hidden} busy={busy === 'hidden'} onClick={() => flip('hidden', !hidden)} testId={`hide-toggle-${product.id}`} />
        Hide from menu
      </label>
      {soldOut && auto && (
        <span className="font-mono text-[10px] uppercase border border-[#FF9F0A]/60 text-[#FF9F0A] px-1.5 py-0.5" data-testid={`sold-out-auto-${product.id}`}>
          {Number(product.region_stock?.[region] ?? product.stock ?? 0) > 0 ? 'Restocked · switch off to sell' : 'Auto · 0 stock'}
        </span>
      )}
      {waiting > 0 && (
        <span className="font-mono text-[10px] uppercase border border-[#39FF14]/60 text-[#39FF14] px-1.5 py-0.5" data-testid={`restock-waiting-${product.id}`}>{waiting} waiting</span>
      )}
      <RestockPushPreview target={restock} onDone={(changed) => { setRestock(null); if (changed) onChange?.(); }} />
    </div>
  );
};
